import { useNavigate } from 'react-router-dom';
import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';
import { useEffect, useCallback, useMemo, useRef, useState } from 'react';
import PATH from '../../../../constants/url';
import { getDpSnsExists, getDpSnsSignin } from '../../../../assets/js/comm';

import MSG from '../../../../constants/message';
import ToastPopup from '../../../../components/comm/ToastPopup';
import URL from '../../../../constants/url';

const NaverRedirectPage = () => {
  const navigate = useNavigate();
  const isProcessing = useRef(false);

  const authCode = useMemo(() => {
    return new window.URL(window.location.href).searchParams.get('code');
  }, []);

  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [sec, setSec] = useState(3);

  const [redirecting, setRedirecting] = useState(false);
  const [baseMsg, setBaseMsg] = useState('');

  const intervalRef = useRef(null);
  const timeoutRef = useRef(null);

  const clearTimers = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    intervalRef.current = null;
    timeoutRef.current = null;
  };

  // 공통 카운트다운 시작 함수
  const startRedirect = (message, seconds = 3) => {
    clearTimers();
    setBaseMsg(message);
    setSec(seconds);
    setToast(true);
    setRedirecting(true);

    intervalRef.current = setInterval(() => {
      setSec((s) => (s > 0 ? s - 1 : 0));
    }, 1000);

    timeoutRef.current = setTimeout(() => {
      navigate(PATH.LANDING, { replace: true });
    }, seconds * 1000);
  };

  // 카운트다운 문구 갱신
  useEffect(() => {
    if (redirecting) {
      setToastMessage(`${baseMsg} ${sec}초 후 \n로그인 화면으로 이동합니다.`);
    }
  }, [redirecting, baseMsg, sec]);

  // 마운트/언마운트 타이머 정리
  useEffect(() => {
    return () => clearTimers();
  }, []);

  const oauthLogin = useCallback(async (code) => {
    if (isProcessing.current) return;

    isProcessing.current = true;

    try {
      const res = await axiosApi.post("/oauth/naver", { code });
      //console.log('토큰을 넘겨줘 : ', res);

      const accessToken = res.data.result.tokens.accessToken;
      // const email = res.data.result.tokens.email;

      getDpSnsExists('naver', accessToken)
        .then(async (res) => {
          //false = 가입 안되어있음 or 연동 안되어있음
          if (!res) {
            navigate(PATH.IDENTITY, { replace: true, state: { sns: 'naver', accessToken: accessToken, /*email : email*/ } });
          } else {
            const pushToken = sessionStorage.getItem('pushToken') || '';
            const signRes = await getDpSnsSignin({ sns: 'naver', accessToken: accessToken, pushToken: pushToken });

            if (signRes?.accessToken !== undefined && signRes?.accessToken !== "") {
              const jToken = signRes?.accessToken;
              const refreshToken = signRes?.refreshToken;
              const requestLoginUrl = "/signup/loginUser"; //"/signup/user";

              const requestOptions = {
                headers: {
                  Authorization: `Bearer ${jToken}`,
                }
                , params: {
                  refreshToken: refreshToken
                }
              }

              await axiosApi.post(requestLoginUrl, {}, requestOptions)
                .then((res) => {
                  if (Number(res.data.resultCode) === Number(CODE.RCV_SUCCESS)) {
                    const aftcrUser = res.data.result.aftcrUser;
                    sessionStorage.removeItem("targetHsptl");//병원케어 메뉴 초기화
                    sessionStorage.setItem('loginUser', JSON.stringify(aftcrUser));
                    localStorage.setItem('jToken', jToken);
                    localStorage.setItem("AFTCR_CRTFC_TKN", refreshToken);

                    if (aftcrUser.usrSeCd !== '17') {
                      if (aftcrUser.usrHsptlMap.length > 0) {
                        // 정상케이스
                        navigate(PATH.HOME_CARE_MAIN);
                      } else {
                        // 해당부분은 맵핑된 병원이 없을 경우, 대표병원이 없을 경우, 병원연결 페이지가 뜨도록 조정해야함.
                        navigate(PATH.HOSPITAL_LINK);
                      }
                    } else {
                      //해외비대면인 경우
                      navigate(URL.CONTACTLESS_MAIN);
                    }
                  } else {
                    startRedirect(MSG.ERR_PSSUSR + "\n사용자의 " + MSG.ERR_AUTH);
                  }
                })
                .catch((err) => {
                  console.log(" ================> RCV_ERROR_SERVER ", err);
                })

            } else {
              alert(MSG.ERR_PSSUSR + "\n사용자의 " + MSG.ERR_AUTH);
            }
          }
        })
        .catch((err) => {
          alert(err)
          if (err.response.status === Number(CODE.RCV_BAD_UNAUTH)) {
          }
        });

    } catch (err) {
      console.error("api/oauth/naver 호출 중 오류 : ", err);
    } finally {
      isProcessing.current = false;
    }
  }, []);

  useEffect(() => {
    if (authCode) {
      oauthLogin(authCode);
    }
  }, [authCode, oauthLogin]);

  return (
    <>
      <div>로그인 중입니다...</div>
      {toast && (
        <ToastPopup
          setToast={setToast}
          position={"center"}
          message={toastMessage}
        />
      )}
    </>
  );
};

export default NaverRedirectPage;
